// extracted by mini-css-extract-plugin
var _1 = "AnnotationCreate-module__actionsContainer--p5ib7";
var _2 = "AnnotationCreate-module__active--LuU83";
var _3 = "AnnotationCreate-module__animateUploadProgressBarWidth--p1Z_c";
var _4 = "AnnotationCreate-module__animatedBackground--Sm5E6";
var _5 = "AnnotationCreate-module__annotationInputContainer--p83HH";
var _6 = "AnnotationCreate-module__annotationInputGroup--KeMws";
var _7 = "AnnotationCreate-module__container--ZSVJG";
var _8 = "AnnotationCreate-module__icon--MI_iC";
var _9 = "AnnotationCreate-module__infoIconContainer--qYfAs";
var _a = "AnnotationCreate-module__input--RiqO1";
var _b = "AnnotationCreate-module__inputContainer--O8zRn";
var _c = "AnnotationCreate-module__linkEditorPopOver--oBBLy";
var _d = "AnnotationCreate-module__submitButtonGroupContainer--Qx0TC";
export { _1 as "actionsContainer", _2 as "active", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "annotationInputContainer", _6 as "annotationInputGroup", _7 as "container", _8 as "icon", _9 as "infoIconContainer", _a as "input", _b as "inputContainer", _c as "linkEditorPopOver", _d as "submitButtonGroupContainer" }
